import { ref, computed } from 'vue';

const formatCurrency = (number: number) => {
  var formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  return formatter.format(number);
};

/**
 * Create a reference limmited to a range of values between inf and sup (both included).
 */
function valueBetween(infLimit:number = -Infinity ,supLimit: number = Infinity, initialValue: number) {
    const watchedValue = ref(initialValue)
    const handler = computed(
        {
            get: () => {
                return watchedValue.value
            },
            set: (value: number) => {
                if (value <= supLimit && value >= infLimit) {
                    watchedValue.value = value
                } 
            }
        })
    return [watchedValue, handler]
}

export { formatCurrency, valueBetween };
